/* Copyright (c) 2023 Xperi. All Rights Reserved. */

export const SET_IS_ERROR_OSD_ACTIVE = 'SET_IS_ERROR_OSD_ACTIVE';

export const SET_ERROR_OSD = 'SHOW_ERROR_OSD';
